import { Nav, Navbar, Container } from "react-bootstrap";
import Logo from "../assets/logo2.png";

const Header = () => {
  return (
    <>
      <Navbar
        collapseOnSelect
        expand="lg"
        variant="light"
        className="shadow-sm border-bottom d-print-none bg-white"
      >
        <Container>
          <Navbar.Brand href="/home">
            <img
              src={Logo}
              height="40"
              className="d-inline-block align-top"
              alt="Expresso Embaixador"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto text-dark">
              <Nav.Link href="/consultaBilhetes">Consulta BPe</Nav.Link>
              <Nav.Link href="/relatorioBilhetes">Bilhetagem</Nav.Link>
              <Nav.Link href="/relatorioMovimento">Movimento</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Header;
